module.exports = __webpack_public_path__ + "static/img/teknisa-branca.9f347a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/client/teknisa-branca.png
// module id = Lt/m
// module chunks = 1